import { getMypageChatAllUnread } from "../../api/v1/mypage/chat/all/unread/get"
import { MypageChantAllUnreadGetInputModel } from "../../api/v1/mypage/chat/all/unread/GetInputModel"

export const fetchChatUnreadCount = (): Promise<number> => {
  return getMypageChatAllUnread(new MypageChantAllUnreadGetInputModel()).then(
    (v) => v.unread_message_count,
  )
}
